import gql from 'graphql-tag';

// antiguo Query portal
export const getReinforcements = gql`
  query getChallengeCoursesSubscribed {
    challengeCourses {
      subscribed {
        id
        reservationCode
        name
        shortName
        type {
          idType
          name
        }
        course {
          id
        }
        description
        shortDescription
        date
        today
        isRescheduled
        capacity
        address
        idZoom
        link
        startTime
        endTime
        professor
        isSubscribed
        tag {
          subscrib
          remote
          present
          free
        }
        modality {
          idModality
          name
        }
      }
    }
  }
`;

// nuevo Query de App
export const getReinforcementsApp = gql`
  query getChallengeCoursesSubscribed {
    academicReinforcement {
      subscribedToSchedule {
        id
        reservationCode
        name
        shortName
        type {
          idType
          name
        }
        course {
          id
        }
        description
        shortDescription
        date
        today
        capacity
        address
        idZoom
        link
        startTime
        endTime
        classroomCode
        professor
        isSubscribed
        tag {
          subscrib
          remote
          present
          free
        }
        modality {
          idModality
          name
        }
        isRescheduled
      }
    }
  }
`;

// ok
export const getCoursesWithReinforcements = gql`
  query getCoursesWithReinforcements($period: String!) {
    academicReinforcement {
      coursesWithReinforcement(period: $period) {
        id
        catalog
        name
        hasWorkshops
        hasTutorships
      }
    }
  }
`;

// ok se retira isRescheduled porque no está en app
export const getReinforcementsByCourse = gql`
  query getReinforcementsByCourse($idCourse: String!, $period: String!) {
    academicReinforcement {
      reinforcementsByCourse(
        parameters: { idCourse: $idCourse, period: $period }
      ) {
        reinforcements {
          isRescheduled
          id
          name
          isFeatured
          nameTeacher
          date
          isCancel
          hourStart
          hourEnd
          modality {
            code
            description
          }
          classRoomCode
          hasCrossing
          isSubscribed
          type {
            code
            description
          }
          isToday
          vacancies
        }
        featureds {
          isRescheduled
          id
          name
          isFeatured
          nameTeacher
          date
          hourStart
          hourEnd
          modality {
            code
            description
          }
          classRoomCode
          hasCrossing
          isSubscribed
          type {
            code
            description
          }
          isToday
          vacancies
        }
        eventsWaitingList {
          isRescheduled
          id
          name
          isFeatured
          nameTeacher
          date
          hourStart
          hourEnd
          modality {
            code
            description
          }
          classRoomCode
          hasCrossing
          isSubscribed
          type {
            code
            description
          }
          isToday
          statusWaitingList
        }
      }
    }
  }
`;

// ok. se retira isRescheduled porque no está en app
export const getDetailReinforcementById = gql`
  query getReinforcementByIdPortal(
    $idReinforcement: String!
    $period: String!
  ) {
    academicReinforcement {
      reinforcementByIdPortal(
        parameters: { idReinforcement: $idReinforcement, period: $period }
      ) {
        isRescheduled
        id
        name
        isFeatured
        nameTeacher
        linkMeet
        vacancies
        description
        date
        hourStart
        hourEnd
        modality {
          code
          description
        }
        hasCrossing
        isSubscribed
        type {
          code
          description
        }
        isToday
        classroom
        flat
        campus
        address
        code
        isAccessible
        isExist
        statusWaitingList
      }
    }
  }
`;

export const subscribeReinforcements = gql`
  mutation subscribeReinforcement($reinforcementId: Float!) {
    subscribeReinforcement(parameters: { reinforcementId: $reinforcementId }) {
      status
      data {
        result
        code
        date
        hourStart
        hourEnd
        description
      }
      message
    }
  }
`;

export const unsubscribeReinforcements = gql`
  mutation unsubscribeReinforcement($code: String!) {
    unsubscribeReinforcement(parameters: { code: $code }) {
      status
      data {
        result
        description
      }
      message
    }
  }
`;

export const subscribeToWaitingList = gql`
  mutation SubscribeToWaitingList(
    $parameters: ReinforcementWaitingListSubscribeInput!
  ) {
    subscribeToReinforcementWaitingList(parameters: $parameters) {
      status
      data
      message
    }
  }
`;

export const unsubscribeToWaitingList = gql`
  mutation UnsubscribeToWaitingList(
    $parameters: ReinforcementWaitingListUnsubscribeInput!
  ) {
    unsubscribeFromReinforcementWaitingList(parameters: $parameters) {
      status
      data
      message
    }
  }
`;
